import { Combobox } from '@Components/Combobox';
import { useVenues } from '@Hooks/useVenues';
import { Table } from '@tanstack/react-table';

type VenueFilterValue =
  | {
      operator?: string;
      value?: string;
    }
  | undefined;

interface VenueQuickFilterProps<TData extends object> {
  table: Table<TData>;
}

export default function VenueQuickFilter<TData extends object>({
  table,
}: VenueQuickFilterProps<TData>) {
  const { data: venues, isLoading } = useVenues({ enabled: true });

  const venueColumn = table.getColumn('venueId');

  const venueItems = [
    { value: '', label: 'All venues' },
    ...(venues ?? [])
      .map((venue) => ({
        value: venue.id,
        label: venue.name,
      }))
      .sort((a, b) =>
        a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
      ),
  ];

  const currentFilter = (venueColumn?.getFilterValue() ??
    undefined) as VenueFilterValue;

  const handleChange = (value?: string) => {
    if (!venueColumn) return;

    if (!value) {
      venueColumn.setFilterValue(undefined);
      return;
    }

    venueColumn.setFilterValue({
      operator: 'equals',
      value,
    });
  };

  return (
    <Combobox
      id="venueFilter"
      items={venueItems}
      value={currentFilter?.value ?? ''}
      onChange={handleChange}
      placeholder="All venues"
      disabled={!venues?.length}
      loading={isLoading}
      triggerClassName="w-[300px]"
    />
  );
}
